import dispatcher from '../dispatcher';
import tabStore from '../tab/tab.store';
import addressStore from '../addressbar/addressbar.store';

var elementProto = Object.create(HTMLElement.prototype);

var _handleClick = function(el, index) {
	var self = this;
	el.addEventListener('click', function(e) {
		var storeData = tabStore.getData()[self._id];

		if (!storeData) return;
		if (storeData.index === index) return;

		dispatcher.dispatch({
			type: 'tab:to',
			id: self._id,
			index: index
		});
	});
}

var _handleStore = function() {
	var storeData = tabStore.getData()[this._id];
	var index;

	if (!storeData) return;
	if (storeData.index === null) return;
	if (storeData.index === this._index) return;

	if (this._items[this._index]) {
		this._items[this._index].classList.remove('active');
		this._items[this._index].setAttribute('aria-selected', 'false');
	}

	this._index = storeData.index;

	if (this._items[this._index]) {
		this._items[this._index].classList.add('active');
		this._items[this._index].setAttribute('aria-selected', 'true');
	}
}

elementProto.createdCallback = function() {
	this._index = 0;

	this.handleStore = _handleStore.bind(this);
	this.handleClick = _handleClick.bind(this);
}
elementProto.attachedCallback = function() {
	var self = this;

	this._items = this.getElementsByTagName('button');
	this._id = this.getAttribute('data-id');

	Array.prototype.forEach.call(this._items, this.handleClick);

	Array.prototype.forEach.call(this._items, function(item) {
		if (item.classList.contains('active')) {
			item.setAttribute('aria-selected', 'true');
		} else {
			item.setAttribute('aria-selected', 'false');
		}
	});

	this.handleStore();
	tabStore.subscribe(this.handleStore)
}
elementProto.detachedCallback = function() {
	tabStore.unsubscribe(this.handleStore)
}

document.registerElement('tab-switch', {
	prototype: elementProto
});